"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactFinalForm = require("react-final-form");
var _reactFinalFormArrays = require("react-final-form-arrays");
var _components = require("@folio/stripes/components");
var _utils = require("../../utils");
var _validators = require("../../validators");
var _CustomPropertiesRule = _interopRequireDefault(require("./CustomPropertiesRule"));
var _hooks = require("../../hooks");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const CustomPropertiesFilterField = _ref => {
  let {
    customProperties = [],
    fields,
    index,
    intlKey: passedIntlKey,
    intlNS: passedIntlNS,
    labelOverrides = {},
    name
  } = _ref;
  const groupedCustomProperties = (0, _utils.groupCustomPropertiesByCtx)(customProperties);
  const {
    change,
    mutators: {
      push
    }
  } = (0, _reactFinalForm.useForm)();
  const {
    values
  } = (0, _reactFinalForm.useFormState)();
  const kintIntl = (0, _hooks.useKintIntl)(passedIntlKey, passedIntlNS);
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_reactFinalForm.Field, {
      id: `input-custprop-${index}`,
      label: kintIntl.formatKintMessage({
        id: 'customProperty',
        overrideValue: labelOverrides.customProperty
      }),
      name: `${name}.customProperty`,
      placeholder: " ",
      render: fieldProps => {
        const sortedGroupedCustProps = Object.entries(groupedCustomProperties)?.sort((a, b) => {
          if (a[0] === 'isNull') return -1; // Make sure noContext is at top

          if (a[0].toLowerCase() < b[0].toLowerCase()) return -1;
          if (a[0].toLowerCase() > b[0].toLowerCase()) return 1;
          return 0;
        });
        return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_components.Select, {
          ...fieldProps,
          placeholder: null // placeholder default causes issues
          ,
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("option", {
            value: "",
            children: " "
          }, "empty-option"), sortedGroupedCustProps.map(_ref2 => {
            let [key, value] = _ref2;
            return /*#__PURE__*/(0, _jsxRuntime.jsx)("optgroup", {
              label: key === 'isNull' ? '-' : key,
              children: value.map(v => {
                return /*#__PURE__*/(0, _jsxRuntime.jsx)("option", {
                  value: v.name,
                  children: v.retired ? kintIntl.formatKintMessage({
                    id: 'customProperty.retiredName',
                    overrideValue: labelOverrides.retiredName
                  }, {
                    name: v.label
                  }) : v.label
                }, v.id);
              })
            }, `custom-property-optgroup-${key}`);
          })]
        });
      },
      required: true,
      validate: _validators.required
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      "data-testid": `selected-custprop-name-${index}`,
      id: `selected-custprop-name-${index}`,
      style: {
        display: 'none'
      },
      children: customProperties.find(t => t.name === fields.value[index]?.customProperty)?.label ?? ''
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_components.Row, {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_components.Col, {
        xs: 2
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_components.Col, {
        xs: 4,
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_components.Label, {
          id: "rule-column-header-comparator",
          required: true,
          children: kintIntl.formatKintMessage({
            id: 'comparator',
            overrideValue: labelOverrides.comparator
          })
        })
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_components.Col, {
        xs: 4,
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_components.Label, {
          id: "rule-column-header-value",
          required: true,
          children: kintIntl.formatKintMessage({
            id: 'value',
            overrideValue: labelOverrides.value
          })
        })
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_components.Col, {
        xs: 2
      })]
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactFinalFormArrays.FieldArray, {
      name: `${name}.rules`,
      children: _ref3 => {
        let {
          fields: ruleFields
        } = _ref3;
        return ruleFields.map((ruleFieldName, ruleFieldIndex) => /*#__PURE__*/(0, _jsxRuntime.jsx)(_CustomPropertiesRule.default, {
          ariaLabelledby: `selected-custprop-name-${index}`,
          clearRuleValue: () => change(`filters[${index}].rules[${ruleFieldIndex}].value`, ''),
          custPropDefinition: customProperties.find(t => t.name === fields.value[index].customProperty),
          index: ruleFieldIndex,
          labelOverrides: labelOverrides,
          name: ruleFieldName,
          onDelete: () => ruleFields.remove(ruleFieldIndex),
          value: values.filters[index]?.rules[ruleFieldIndex]
        }, ruleFieldName));
      }
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_components.Button, {
      "data-test-add-rule-btn": true,
      disabled: !fields.value[index]?.customProperty,
      onClick: () => push(`${name}.rules`),
      children: kintIntl.formatKintMessage({
        id: 'addRule',
        overrideValue: labelOverrides.addRule
      })
    })]
  });
};
CustomPropertiesFilterField.propTypes = {
  customProperties: _propTypes.default.arrayOf(_propTypes.default.object),
  fields: _propTypes.default.object,
  index: _propTypes.default.number,
  intlKey: _propTypes.default.string,
  intlNS: _propTypes.default.string,
  labelOverrides: _propTypes.default.object,
  name: _propTypes.default.string
};
var _default = exports.default = CustomPropertiesFilterField;